import React from "react"
import { getFormattedReadingTime } from "../utils/blogListHelpers"

export default ({ numberOfWords, className }) => (
  <div className={className}>{getFormattedReadingTime(numberOfWords)}</div>
)
